import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SlotsComponent } from './slots.component';
import { SlotsResolve, SlotsRescheduleResolve } from './slots.resolve';
import { BookedSlotsComponent } from './booked-slots/booked-slots.component';
import { HasAppointmentDetail } from '../shared/services/auth-guard.service';
import { ErrorsComponent } from '../shared/components/errors/errors.component';


const slotsRoutes: Routes = [
    {
        path: 'slots', component: SlotsComponent, 
        // resolve: {
        //     slotsData: SlotsResolve
        // }
    },
    {
        path: 'slots/reschedule', component: SlotsComponent,
        // resolve: {
        //     slotsData: SlotsRescheduleResolve
        // }
    },
    {
        path: 'slots/confirmed', component: BookedSlotsComponent, canActivate: [HasAppointmentDetail]
    },
    {
        path:'error',component:ErrorsComponent
    }
];
 
@NgModule({
    imports: [
        RouterModule.forChild(slotsRoutes)
    ],
    exports: [RouterModule],
    providers: []
})
export class SlotsRoutingModule { }


// WEBPACK FOOTER //
// ./src/app/slots/slots-routing.module.ts